export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.4.29-1619.11",
  commitId: "4d68638b15bdc4e24d1c56e8537c2a8e2260b702",
  commitTime: "2026-04-29T16:19:11.000Z",
});
